export default __webpack_public_path__ + "static/media/CoachingDiary.97140cae168e1a138984af43fc8a7a12.webp";